<template>
  <div data-aos="fade-right" data-aos-duration="1000" class="section">
    <div class="text-section">
      <h2 class="title">{{ title }}</h2>
      <p class="content" v-html="content" />
    </div>
    <img :src="image" />
  </div>
</template>

<script>
export default {
  name: 'section',
  props: {
    title: String,
    content: String,
    image: String
  }
};
</script>

<style lang="scss" scoped>
.text-section {
  padding: 2em;
  width: 30rem;

  display: flex;
  align-items: center;
}

.content {
  width: 100%;
  text-align: left;
  font-size: 1.4rem;
}

@media only screen and (max-width: 500px) {
  .text-section {
    box-sizing: border-box;
    width: 100%;
  }

  .content {
    font-size: 1.2rem;
  }
}
</style>
